const React = require('react');
const PropTypes = require('prop-types');

const { useState, createElement, useCallback } = React;

const Module = require('./Module');

const ModuleWrapper = (props) => {
    const { manifestStoreConfig, ...otherProps } = props;
    const { resetLimit } = manifestStoreConfig;

    const [attempts, setAttempts] = useState(0);

    const resetFn = useCallback(() => {
        setAttempts((prevAttempts) => {
            const newAttempts = prevAttempts + 1;

            return newAttempts > resetLimit ? prevAttempts : newAttempts;
        });
    }, [resetLimit]);

    if (resetLimit === 0) {
        return createElement(Module, { ...otherProps });
    }

    return createElement(Module, {
        ...otherProps,
        manifestStoreConfig: { resetFn, attempts },
        key: attempts,
    });
};

ModuleWrapper.propTypes = {
    manifestStoreConfig: PropTypes.shape({
        resetLimit: PropTypes.number,
    }),
};

ModuleWrapper.defaultProps = {
    manifestStoreConfig: {
        resetLimit: 3,
    },
};

module.exports = ModuleWrapper;
